import * as React from 'react'

class TaxForm extends React.Component {
    render() {
        return(
            <div className="ecf-form-donate__item-tax-form">
                <div className="ecf-form-donate__item-tax-form-container">
                    <h4 className="ecf-form-donate__item-tax-form--title section-item-title">
                        Would you like to opt for tax deduction?
                    </h4>
                    <div className="ecf-form-donate__item-tax-form-radios">
                        <div>
                            <input
                                name="radioQA"
                                type="radio"
                                id="radioYes"
                                value={true}
                                // checked={this.state.isGoing}
                                // onChange={this.handleInputChange} 
                                />
                            <label htmlFor="radioYes" >
                                <span>
                                    Yes
                                </span>
                            </label>
                        </div>
                        <div>
                            <input
                                name="radioQA"
                                type="radio"
                                id="radioNo"
                                value={false}
                                // checked={this.state.isGoing}
                                // onChange={this.handleInputChange} 
                                />
                            <label htmlFor="radioNo" >
                                <span>
                                    No
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TaxForm